import React from 'react';
import { MerchantInvoice, MerchantBillingSettings, InvoiceTemplateId } from '../../types/gst';
import { ClassicGstTemplate } from './templates/ClassicGstTemplate';
import { StylishModernTemplate } from './templates/StylishModernTemplate';
import { ThermalPosTemplate } from './templates/ThermalPosTemplate';
import { CorporateEleganceTemplate } from './templates/CorporateEleganceTemplate';
import { ObsidianSignatureTemplate } from './templates/ObsidianSignatureTemplate';

interface Props {
  invoice: MerchantInvoice;
  settings?: MerchantBillingSettings;
  overrideTemplateId?: InvoiceTemplateId;
}

export const InvoiceTemplateRenderer: React.FC<Props> = ({
  invoice,
  settings,
  overrideTemplateId
}) => {
  const activeTemplate = overrideTemplateId || invoice.templateId || 'CLASSIC_GST';

  switch (activeTemplate) {
    case 'STYLISH_MODERN':
      return <StylishModernTemplate invoice={invoice} settings={settings} />;
    case 'THERMAL_POS':
      return <ThermalPosTemplate invoice={invoice} settings={settings} />;
    case 'CORPORATE_ELEGANCE':
      return <CorporateEleganceTemplate invoice={invoice} settings={settings} />;
    case 'OBSIDIAN_SIGNATURE':
      return <ObsidianSignatureTemplate invoice={invoice} settings={settings} />;
    case 'CLASSIC_GST':
    default:
      return <ClassicGstTemplate invoice={invoice} settings={settings} />;
  }
};
